function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.0004 6.85718C25.6886 6.85698 20.5716 11.9736 20.5714 18.2854C20.5712 24.5972 25.6878 29.7141 31.9997 29.7143C38.3115 29.7145 43.4284 24.5979 43.4286 18.2861L43.4286 18.2833C43.421 11.9763 38.3102 6.8652 32.0032 6.85718H32.0004ZM25.1429 18.2855C25.143 14.4989 28.2124 11.4292 31.9989 11.4286C35.7846 11.4342 38.852 14.502 38.8572 18.2877C38.8561 22.074 35.7863 25.143 31.9998 25.1429C28.2127 25.1428 25.1428 22.0726 25.1429 18.2855ZM32 36.5715C40.0605 36.5715 46.7289 42.5319 47.838 50.2858H16.162C17.2711 42.5319 23.9395 36.5715 32 36.5715ZM32 32C20.6387 32 11.4286 41.2102 11.4286 52.5715C11.4286 53.8338 12.4519 54.8572 13.7143 54.8572H50.2857C51.5481 54.8572 52.5714 53.8338 52.5714 52.5715C52.5714 41.2102 43.3613 32 32 32Z",
  fill: "#00013A"
});

var SvgAccountIcon = function SvgAccountIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccountIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account-icon.3c6d6590.svg";
export { ForwardRef as ReactComponent };